// ActivityStream.js
import React, { useMemo } from "react";
import "./ActivityStream.scss";

export default function ActivityStream({ sessions = [], limit = 20 }) {
  const recentActivity = useMemo(() => {
    if (!sessions || sessions.length === 0) return [];

    return sessions
      .map(s => ({
        sessionCode: s.sessionCode || s.code,
        timestamp: new Date(s.startTime || s.timestamp),
        score: s.meanScore,
        responseCount: s.responseCount,
      }))
      .filter(a => !isNaN(a.timestamp.getTime()))
      .sort((a, b) => b.timestamp - a.timestamp)
      .slice(0, limit);
  }, [sessions, limit]);

  const getIcon = (score) => {
    if (score >= 80) return "🟢";
    if (score >= 60) return "🟡";
    return "🔴";
  };

  const formatTimeAgo = (date) => {
    const seconds = Math.floor((new Date() - date) / 1000);
    if (seconds < 60) return `${seconds}s ago`;
    if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
    if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
    return `${Math.floor(seconds / 86400)}d ago`;
  };

  return (
    <div className="activityStream">
      {recentActivity.map((activity, idx) => (
        <div key={`${activity.sessionCode}-${idx}`} className="activity-item">
          <span className="activity-icon">{getIcon(activity.score)}</span>
          <div className="activity-content">
            <div className="activity-text">
              <strong>{activity.sessionCode}</strong> completed{" "}
              {activity.responseCount} insight{activity.responseCount !== 1 ? "s" : ""}
              {activity.score != null && (
                <span className="activity-score"> · {Math.round(activity.score)}% avg</span>
              )}
            </div>
            <div className="activity-time">{formatTimeAgo(activity.timestamp)}</div>
          </div>
        </div>
      ))}

      {recentActivity.length === 0 && (
        <div className="activity-empty">No recent activity</div>
      )}
    </div>
  );
}